import { Page } from './types'

const render = () => {
    return <>
        <p>Cluster Manager requires a database for storing its data. We currently support MongoDB version 4.0 or later,
            and AWS DocumentDB 4.0 when deployed to AWS. The only information you need to connect your database to the
            Cluster Manager is the connection string. This typically has the form <code>mongodb://[username:password@]host[:port]</code>
        </p>
    </>
}

const InstallDatabase : Page<{}> = { key: 'install-database', title: 'Installing a database', render }

export default InstallDatabase